module.exports = [
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 1640.73
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 1541.5
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 1430.37
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 1340.53
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 1292.87
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 1302.2
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 1313.45
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 946.83
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 892.73
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 854.13
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 839.33
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 843.2
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 872.23
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 887.65
  }
]
